module.exports = __webpack_public_path__ + "img/05n.ed926bae.png";